import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";

import {
  disableBodyScroll,
  enableBodyScroll,
} from "@root/misc/disableBodyScroll";

import { LineupSlotInfoWithPickedOption } from "../types";
import { ScoreDetails } from "../ui/ScoreDetails";

interface IScoreDetailsContext {
  slotInfo?: LineupSlotInfoWithPickedOption;
  forceClose: () => void;
  open: (slotInfo: LineupSlotInfoWithPickedOption) => void; 
}

export const ScoreDetailsContext = React.createContext<IScoreDetailsContext>({
  forceClose: () => {},
  open: () => {},
});

export const useScoreDetailsContext = () => useContext(ScoreDetailsContext);

export const WithScoreDetails: React.FC<PropsWithChildren<{}>> = React.memo(
  ({ children }) => {
    const [slotInfo, setSlotInfo] = useState<LineupSlotInfoWithPickedOption>();
    const context: IScoreDetailsContext = useMemo(() => ({
      forceClose: () => setSlotInfo(undefined),
      open: setSlotInfo,
      slotInfo,
    }), [slotInfo, setSlotInfo]);

    const isOpen = !!slotInfo;

    useEffect(() => {
      if (isOpen) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }, [isOpen]);

    useEffect(() => {
      return () => {
        // make sure to enable body-scroll on unmount
        enableBodyScroll();
      };
    }, []);

    return (
      <ScoreDetailsContext.Provider value={ context }>
        <ScoreDetails />
        {children}
      </ScoreDetailsContext.Provider>
    );
  }
);
